import { Link } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";
import { mediaUrl } from "../lib/api";
import { iconFor } from "../lib/categories";
import Countdown from "./Countdown";

export default function OfferCard({ offer, action }) {
  const Icon = iconFor(offer.category);
  return (
    <div className="bg-white border border-zinc-200 rounded-lg overflow-hidden flex flex-col hover-lift" data-testid={`offer-card-${offer.id}`}>
      <Link to={`/b/${offer.listing_id}`} className="relative aspect-[16/9] bg-zinc-100 block overflow-hidden">
        {offer.photo ? (
          <img src={mediaUrl(offer.photo)} alt={offer.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-[#FFCC00]">
            <Icon className="w-12 h-12 text-black" />
          </div>
        )}
        {offer.label && (
          <span className="absolute top-3 left-3 px-3 py-1 rounded-md bg-black text-[#FFCC00] font-display font-bold text-sm" data-testid={`offer-label-${offer.id}`}>
            {offer.label}
          </span>
        )}
      </Link>
      <div className="p-5 flex-1 flex flex-col">
        <p className="font-display text-xl font-bold leading-tight">{offer.title}</p>
        <p className="text-sm text-zinc-600 mt-2 whitespace-pre-wrap">{offer.description}</p>
        <div className="mt-auto pt-4 flex items-center justify-between gap-2 text-xs text-zinc-500">
          <Link to={`/b/${offer.listing_id}`} className="font-semibold text-black underline truncate">{offer.business_name}</Link>
          <span className="flex items-center gap-1 shrink-0"><MapPin className="w-3 h-3" /> {offer.town}</span>
        </div>
        <div className="flex items-center justify-between mt-3">
          <span className="inline-flex items-center gap-1 text-[11px] font-mono uppercase tracking-widest text-zinc-500">
            <Clock className="w-3 h-3" /> <Countdown to={offer.expires_at} testid={`offer-countdown-${offer.id}`} />
          </span>
          {action}
        </div>
      </div>
    </div>
  );
}
